module.exports = __webpack_public_path__ + "img/paypal-logo.3889e444.png";